import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsPanel = ({ metrics }) => {
  const metricCards = [
    {
      id: 'encounters',
      label: 'This Month',
      value: metrics?.encountersThisMonth,
      icon: 'Heart',
      color: 'accent',
      trend: metrics?.encounterTrend,
      trendLabel: 'vs last month'
    },
    {
      id: 'compatibility',
      label: 'Compatibility',
      value: `${metrics?.compatibilityScore}%`,
      icon: 'TrendingUp',
      color: 'success',
      trend: metrics?.compatibilityTrend,
      trendLabel: 'this week'
    },
    {
      id: 'scheduled',
      label: 'Scheduled',
      value: metrics?.upcomingScheduled,
      icon: 'Calendar',
      color: 'primary',
      trend: null,
      trendLabel: 'upcoming'
    },
    {
      id: 'streak',
      label: 'Current Streak',
      value: `${metrics?.currentStreak} days`,
      icon: 'Flame',
      color: 'warning',
      trend: null,
      trendLabel: 'keep it up!'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {metricCards?.map((metric) => (
        <div
          key={metric?.id}
          className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-therapeutic-sm hover:shadow-therapeutic transition-therapeutic"
        >
          <div className="flex items-start justify-between mb-3 md:mb-4">
            <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-${metric?.color}/10 rounded-md`}>
              <Icon name={metric?.icon} size={20} color={`var(--color-${metric?.color})`} />
            </div>
            
            {metric?.trend !== null && (
              <div className={`flex items-center gap-1 ${metric?.trend >= 0 ? 'text-success' : 'text-error'}`}>
                <Icon 
                  name={metric?.trend >= 0 ? 'TrendingUp' : 'TrendingDown'} 
                  size={16} 
                  color="currentColor" 
                />
                <span className="text-xs md:text-sm font-medium">
                  {Math.abs(metric?.trend)}%
                </span>
              </div>
            )}
          </div>

          <div className="space-y-1">
            <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground">
              {metric?.value}
            </p>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">
              {metric?.label}
            </p>
            {metric?.trendLabel && (
              <p className="text-xs text-muted-foreground/80">
                {metric?.trendLabel}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsPanel;